import { render, staticRenderFns } from "./PayResultDialog.vue?vue&type=template&id=5b9f2485&"
import script from "./PayResultDialog.vue?vue&type=script&lang=js&"
export * from "./PayResultDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports